import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalService } from '../../../common/services/modal.service';
import { AccountApiService } from '../../../services/account.api.service';
import { AlertifyService } from '../../../services/alertify.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../hub/show.info.modal/show.info.modal.provider';
import { AddSpiderEventsModalActions, AddSpiderEventsModalData } from './add.spider.events.modal.provider';
import { SchedulerApiService } from '../../../services/scheduler.api.service';
import { VisitorApiService } from '../../../services/visitor.api.service';

@Component({
  templateUrl: './add.spider.events.modal.component.html',
  styleUrls: ['./add.spider.events.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddSpiderEvenetsModalComponent extends BaseComponent {
  public data: AddSpiderEventsModalData;
  public isApproved = true;
  public totalEvents = 0;
  public isFetchingMoreInfo = false;
  public isSaving = false;
  @ViewChild('div') public div: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<AddSpiderEvenetsModalComponent>,
    private actions: AddSpiderEventsModalActions,
    public imageService: ImageService,
    private alertify: AlertifyService,
    private accountApiService: AccountApiService,
    private schedulerApiService: SchedulerApiService,
    private visitorApiService: VisitorApiService,
    private modalService: ModalService,
    data: AddSpiderEventsModalData
  ) {
    super();
    this.data = data;
    this.data.events.forEach((x) => {
      x.events = x.events.filter((y) => y.eventTimes && y.eventTimes.length);
      x.events.forEach((y) => (y.checked = true));
      this.totalEvents += x.events.length;
    });
    console.log(this.data.events);
  }

  public setAccount(hubName) {
    this.data.hubName = hubName;
  }

  public toggleAll() {
    this.data.events.forEach((e) => {
      e.events.forEach((x, i) => {
        x.checked = !x.checked;
      });
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  public async getMoreInfo(event) {
    const e = this.getEventFromModal(event);
    e && (e.isUpdating = true);

    const result: { success: boolean; info: any; message: string } = await this.schedulerApiService
      .eventbriteEventDetails(event.eventLink)
      .finally(() => {
        e.isUpdating = false;
      })
      .toPromise();

    if (e) {
      e.description = result.info && result.info.description ? result.info.description : e.description;
      if (e.multiHosts && e.multiHosts.length) {
        e.multiHosts[0].img = result.info.hostImg;
      }
      e.isUpdated = true;
      console.log('Updated', e);
    }
  }

  public async confirm(event: ButtonTriggerEvent) {
    if (!this.data.hubName) {
      event.complete();
      alert('Please select an account.');
      return;
    }
    // if (this.data.hubName !== 'test') {
    //     event.complete();
    //     alert('This experimental feature is only available for the account "test"');
    //     return;
    // }

    let events: any[] = [];
    this.data.events.forEach((x) => {
      events.push(...x.events.filter((x) => x.checked));
    });
    console.log('events count:', events.length);

    if (this.data.socialName.includes('eventbrite')) {
      this.isFetchingMoreInfo = true;
      let eventbriteEvents = await this.visitorApiService
        .getEvents(this.data.hubName, {
          socialName: 'eventbrite',
          projection:
            '-analytics -isBlocked -blacklisted -isApproved -categories -changeHistory -customCategories -eventTimesText -isOnlineEvent -isChoice -isCustom -isFacebookEvent -isHideTicketUrl -isHubCreated -isHybridEvent -isManuallyCreated -isToBeExport -nameId -title -timestamp',
        })
        .toPromise();

      // using Eventbrite internal API will only get one sentence event summary, so we need to get the detailed description and host info
      // if description contains "ig-eventbrite-event-full-description" means it is full, otherwise it is the summary
      for (const event of events) {
        const exist = eventbriteEvents.find((x) => x.socialId === event.socialId);
        if (exist) {
          if (exist.description && !exist.description.includes('ig-eventbrite-event-full-description')) {
            await this.getMoreInfo(event);
          } else {
            event.isUpdated = true;
          }
        } else {
          await this.getMoreInfo(event);
        }
      }
      this.isFetchingMoreInfo = false;

      events = [];
      this.data.events.forEach((x) => {
        events.push(...x.events.filter((x) => x.checked));
      });
    }

    this.isSaving = true;
    this.accountApiService
      .saveSpiderEvents(this.data.hubName, {
        isApproved: this.isApproved,
        events,
        // socialName: `${this.data.socialName}${spiderSources.any((x) => x === this.data.socialName) ? '|spider' : ''}`,
        socialName:
          this.data.socialName === 'facebook'
            ? 'facebook|spider'
            : this.data.socialName === 'eventbrite'
            ? 'eventbrite|internal-api'
            : this.data.socialName,
      })
      .finally(() => {
        event.complete();
        this.isSaving = false;
      })
      .subscribe((result) => {
        if (result) {
          if (result.saved.length === this.totalEvents) {
            this.alertify.successfully('Save events');
            this.dialogRef.close();
          } else {
            let icons = [],
              text = [];
            if (result.saved.length) {
              icons.push({ icon: 'check', color: 'green' });
              text.push(`${result.saved.length} events saved successfully`);
            }
            if (result.updated.length) {
              icons.push({ icon: 'cached', color: 'green' });
              text.push(`${result.updated.length} events updated`);
            }
            if (result.merged.length) {
              icons.push({ icon: 'list', color: 'green' });
              text.push(`${result.merged.length} events merged`);
            }
            if (result.existed.length) {
              icons.push({ icon: 'error_outline', color: 'orange' });
              text.push(`${result.existed.length} events not saved due to existed`);
            }
            if (result.notSaved.length) {
              icons.push({ icon: 'error_outline', color: 'red' });
              text.push(
                `${result.notSaved.length} events not saved due to missing properties, please check event info and address`
              );
            }
            if (result.approvalStatusNotChanged.length) {
              text.push(`<hr style="width:680px;height:unset"/>`);
              text.push(
                `<span style="margin-bottom: 6px">The following events already exist and ${
                  this.isApproved
                    ? '<span style="color:red">unapproved</span>'
                    : '<span style="color:green">approved</span>'
                }, they will stay ${
                  this.isApproved
                    ? '<span style="color:red">unapproved.</span>'
                    : '<span style="color:green">approved.</span>'
                }</span>`
              );
              result.approvalStatusNotChanged.forEach((x, i) => {
                text.push(`<span style="font-size: 14px">${i + 1}: ${x}</span>`);
              });
            }
            this.modalService.show({
              component: ShowInfoModalComponent,
              providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                  provide: InfoModalData,
                  useValue: new InfoModalData('Result', icons, text),
                },
              ],
              panelClass: 'width-modal-3',
            });
          }
        }
      });
  }

  private getEventFromModal(event) {
    for (const x of this.data.events) {
      let e = x.events.find((y) => y.socialId === event.socialId);
      if (e) return e;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/add.spider.events.modal/add.spider.events.modal.component.ts